export const REQUEST_FAILED = 'GRADES_REQUEST_FAILED';
export const LIST = 'GRADES_LIST';
export const LIST_SUCCEEDED = 'GRADES_LIST_SUCCEEDED';
export const GET = 'GRADE_GET';
export const GET_SUCCEEDED = 'GRADE_GET_SUCCEEDED';
export const UPDATE = 'GRADE_UPDATE';
export const UPDATE_SUCCEEDED = 'GRADE_UPDATE_SUCCEEDED';
export const REMOVE = 'GRADE_REMOVE';
export const REMOVE_SUCCEEDED = 'GRADE_REMOVE_SUCCEEDED';
export const CREATE = 'GRADE_CREATE';
export const CREATE_SUCCEEDED = 'GRADE_CREATE_SUCCEEDED';
export const SET = 'GRADE_SET';
export const RESET = 'GRADE_RESET';
